import '/Users/tom/GitHub/chromaui/addon-visual-tests/dist/manager.mjs';